/** Moves one item up or down an ordered list; out-of-range moves leave it unchanged. */
export function moveItem<Item>(list: readonly Item[], index: number, delta: -1 | 1): Item[] {
  const target = index + delta;
  if (index < 0 || index >= list.length || target < 0 || target >= list.length) return [...list];
  const next = [...list];
  const [item] = next.splice(index, 1) as [Item];
  next.splice(target, 0, item);
  return next;
}

/** The next free position after the last one (new rows go to the end). */
export function nextPosition(items: readonly { position: number }[]): number {
  return items.reduce((highest, item) => Math.max(highest, item.position + 1), 0);
}
